// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueLazyload from 'vue-lazyload'

//兼容安卓低版本浏览器
import 'babel-polyfill'
// 初始化页面样式
import './assets/styles/reset.css'
// 解决移动端1px问题
import 'styles/border.css'
import 'styles/iconfont.css'
//使用轮播图插件
import 'swiper/dist/css/swiper.css'
//解决部分机型点击300ms延迟
import FastClick from 'fastclick'
//引入ivviewUI
// import iView from 'iview/dist/iview.js'
// import 'iview/dist/styles/iview.css';
// Vue.use(iView);
// import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
// Vue.use(MintUI)
FastClick.prototype.focus = function(targetElement) {
    let length;
    if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
        length = targetElement.value.length;
        targetElement.focus();
        targetElement.setSelectionRange(length, length);
    } else {
        targetElement.focus();
    }
};

// 价格格式化过滤器
Vue.filter('priceConversion', function(priceValue) {
    const price = priceValue ? (priceValue / 100) : 0
    return price
})
Vue.filter('priceFormat', function(price) {
    return isNaN(Number(price)) ? "0.00" : (price / 100).toFixed(2)
})
Vue.filter('commissionPriceFormat', function(price) {
    let _price = isNaN(Number(price)) ? "0" : (price / 100).toFixed(2) + '';
    let arr = _price.split('.')
    if (arr[arr.length - 1] === '00') {
        return arr[0]
    } else if (arr[arr.length - 1].split('')[arr.length - 1] === '0') {
        return _price.substring(0, _price.length - 1)
    } else {
        return _price
    }
})
// 价格格式化过滤器 保留2位小数
Vue.filter('priceConversion2', function(priceValue) {
    if (!priceValue) {
        priceValue = "000"
    }
    const price = (priceValue / 100).toFixed(2)
    return price
})

Vue.filter('conversionMillion', function(value) {
    if (!value) { return 0 }
    if (value >= 10000) {
        var str = value + ''
        var lf = str.slice(0, -4)
        var rt = str.slice(-4).slice(0, 1)
        return (lf + '.' + rt + '万')
    } else {
        return value
    }
})

// 引入VueScrollLock用来阻止父元素的滚动
import VueScrollLock from 'vue-scroll-lock'
import Utils from '@/utils/util'

Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
FastClick.attach(document.body)
Vue.use(VueScrollLock)

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: 'https://image.mryitao.cn/test/2019082715001.png',
    loading: 'https://image.mryitao.cn/test/2019082715001.png',
    attempt: 1
})

/* eslint-disable no-new */
new Vue({
        el: '#app',
        router,
        store,
        components: {
            App
        },
        template: '<App/>',
        methods: {
            info(mes) {
                this.$Message.info(mes);
            }
        }
    })
    /* 路由就是根据网址的不同,返回不同的内容给用户 */

//路由守卫
router.beforeEach((to, from, next) => {
    // 路由跳转动态改变title
    const pageName = to.name || ''
    switch (pageName) {
        case 'materialDetail':
            document.title = '每日一淘好物推荐'
            break
        case 'ProductDetail':
            document.title = '每日一淘'
            break
    }
    let isLogin = Utils.cookieGet("accessToken") ? true : false
        // let banBack = false    //    给个默认值false

    // if (to.meta.banBack !== undefined) {
    // 	banBack = to.meta.banBack
    // }
    // if (banBack) {
    // 	history.pushState(null, null, location.href)
    // }
    // store.commit('updateAppSetting', {     //   updateAppSetting 只是store里面的一个action， 用来改变store里的banBack的值的，具体怎么改这个值 要根据各位的实际情况而定
    // 	banBack: banBack
    // })

    if (isLogin == true) {
        //已经登录状态，直接路由跳转
        next();
    } else {
        //判断当前路由地址是否需要登录
        if (to.meta.isLogin) {
            //未登录则跳转到登陆界面，query:{ Rurl: to.fullPath}表示把当前路由信息传递过去方便登录后跳转回来
            next({
                path: '/login',
                query: {
                    ret: to.fullPath
                }
            });
        } else {
            //无须登陆，直接跳转
            next();
        }
    }
});



// WEBPACK FOOTER //
// ./src/main.js